import { useEffect, useState } from "react";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Bar } from "react-chartjs-2";

interface propsType {
  chartData: any;
}

interface IGridCols {
  label: string;
  value: number;
}

Chart.register(CategoryScale);

const KeywordCategoryChart = (props: propsType) => {
  return (
    <div className="chart-root">
      <Bar
        data={props.chartData}
        options={{
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
          scales: {
            x: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
};

export default KeywordCategoryChart;
